import { render, staticRenderFns } from "./news-subscription.vue?vue&type=template&id=585e7789&"
import script from "./news-subscription.vue?vue&type=script&lang=js&"
export * from "./news-subscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports